import React, {useEffect, useRef, useState} from 'react';
import Select from 'react-select';

import {useSelector, shallowEqual} from 'react-redux';
import {Chatbot} from '../../states/actions';
import {IntNodeComponent, InputComponent, SelectComp, RichTextareaComponent, onEdited} from './Components'
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';



export const DataBlock = React.memo((node) => {
  const {block, start} = useSelector(createSelectNodeData(node.id), shallowEqual);


  if (!block) {
    return null;
  }
  const {
    data,
  } = block;


  return (
    <>
    
      <IntNodeComponent name="Data" icon="data" data={data} node={node} start={start}/>

     
    </>
  );
});


export const DataEditor = ({nodeid, block}) => {
 
  const refTxtProperty = useRef(null);
  const refTxtValue = useRef(null);
  const refRichTextVariable = useRef(null);

  const {data} = block;
  const {data: datafields = {}, datatype, richtext_variable, richtext_content, lawyers_variable, lawyers_active_only} = data || {};
  const [localDatafields, setLocalDatafields] = useState(datafields);

  useEffect(() => {
    if (datafields) {
      (async () => {
        setLocalDatafields(datafields)
      })();
    } 
  }, [datafields]);

  if (!block) {
    return null;
  }


  const addDataField = (e) => {
    e.preventDefault();
    const id = Date.now().toString();
    const text = refTxtProperty.current.value;
    const value = refTxtValue.current.value;
    if (text !== '') {
      Chatbot.setBlockData(block.id, {data: {[id]: {id, text, value}}});
      refTxtProperty.current.value = '';
      refTxtValue.current.value = '';
      onEdited('added');
    }
  };
  const removeDataField = (e, key) => {
    e.preventDefault();
    Chatbot.removeDataBlock(block.id, key);
    onEdited('removed');
  };

return (
  <>
         
     

        {/*  <SelectComp data={data} name="Data" dataname="datatype" placeholder="Set data method" options={variables_datatype} block={block}/> */}

        <div className='tab-container'>
          <div className={`tab btn-section ${datatype === "import" ? 'active' : ''}`} onClick={() => Chatbot.setBlockData(block.id, {datatype: "import"})}>
                    <span></span>
                      Import
                    </div>
                    <div className={`tab btn-section ${datatype === "data" ? 'active' : ''}`} onClick={() => Chatbot.setBlockData(block.id, {datatype: "data"})}>
                      <span></span>
                      Data
          </div>
          <div className={`tab btn-section ${datatype === "richtext" ? 'active' : ''}`} onClick={() => {
            Chatbot.setBlockData(block.id, {
              datatype: "richtext",
              richtext_variable: richtext_variable || '',
              richtext_content: richtext_content || '',
              data: datafields || {},
            });
          }}>
                    <span></span>
                      Rich Text
          </div>
          <div className={`tab btn-section ${datatype === "lawyers" ? 'active' : ''}`} onClick={() => {
            Chatbot.setBlockData(block.id, {
              datatype: "lawyers",
              lawyers_variable: lawyers_variable || '',
              lawyers_active_only: lawyers_active_only !== false,
              data: datafields || {},
            });
          }}>
                    <span></span>
                      Lawyers
          </div>
          </div>

         

          <br/>

          {datatype === "richtext" && (
            <div style={{marginBottom: '15px'}}>
              <small style={{fontStyle: 'italic', color: '#666'}}>
                Use {'{variable_name}'} for variable interpolation • Supports HTML formatting • Perfect for building dynamic content and AI conversation loops
              </small>
            </div>
          )}

          {datatype === "import" && (
            <div style={{marginBottom: '15px'}}>
              <small style={{fontStyle: 'italic', color: '#666'}}>
                Imports data from external sources or URL parameters
              </small>
            </div>
          )}

          {datatype === "data" && (
            <div style={{marginBottom: '15px'}}>
              <small style={{fontStyle: 'italic', color: '#666'}}>
                Set static or dynamic values using variables
              </small>
            </div>
          )}

          {datatype === "lawyers" && (
            <div style={{marginBottom: '15px'}}>
              <small style={{fontStyle: 'italic', color: '#666'}}>
                Loads lawyers from lawyers.json as &quot;Name | crm_id&quot; lines for AI matching
              </small>
            </div>
          )}

          <br/>

          {/* Rich Text Mode: Single variable with CKEditor */}
          {datatype === "richtext" && (
            <>
              <div className="mb-2">
                <label htmlFor="richtext_variable" className="form-label comp-header">
                  Variable Name
                </label>
                <input
                  type="text"
                  id="richtext_variable"
                  name="richtext_variable"
                  className="form-control"
                  placeholder="e.g., problem_advanced"
                  defaultValue={richtext_variable || ''}
                  onChange={onEdited}
                  onBlur={(e) => {
                    Chatbot.setBlockData(block.id, {richtext_variable: e.target.value});
                  }}
                />
              </div>
              
              <div className="mb-2">
                <label className="form-label comp-header">
                  Content (use {'{variable_name}'} for interpolation)
                </label>
                <RichTextareaComponent 
                  key={`richtext_${block.id}_${richtext_content ? 'loaded' : 'empty'}`}
                  data={data} 
                  name="" 
                  dataname="richtext_content" 
                  placeholder="Enter your rich text content with variable placeholders..." 
                  block={block}
                />
              </div>
            </>
          )}

          {/* Lawyers Mode: variable name + active-only toggle */}
          {datatype === "lawyers" && (
            <>
              <div className="mb-2">
                <label htmlFor="lawyers_variable" className="form-label comp-header">
                  Variable Name
                </label>
                <input
                  type="text"
                  id="lawyers_variable"
                  name="lawyers_variable"
                  className="form-control"
                  placeholder="e.g., active_lawyers"
                  defaultValue={lawyers_variable || ''}
                  onChange={onEdited}
                  onBlur={(e) => {
                    Chatbot.setBlockData(block.id, {lawyers_variable: e.target.value});
                  }}
                />
              </div>

              <div className="mb-2">
                <label className="form-label comp-header">
                  <input
                    type="checkbox"
                    checked={lawyers_active_only !== false}
                    onChange={(e) => {
                      Chatbot.setBlockData(block.id, {lawyers_active_only: e.target.checked});
                    }}
                    style={{marginRight: '8px'}}
                  />
                  Active lawyers only
                </label>
              </div>
            </>
          )}

          {/* Data and Import Modes: Name/Value pairs */}
          {datatype !== "richtext" && datatype !== "lawyers" && (
            <>
              <div className='double-input mb-3'>
                <div className='inputs'>
                  <input
                    type="input"
                    id="txtText"
                    className="form-control top"
                    placeholder="Variable Name"
                    ref={refTxtProperty}
                    onKeyPress={(e) => (e.key === 'Enter' ? addDataField(e) : e)}
                  />
                  <input
                    type="input"
                    id="txtValue"
                    className="form-control bottom"
                    placeholder={
                      datatype === "import"
                      ? "variable name"
                      : "value"
                    }
                    ref={refTxtValue}
                    onKeyPress={(e) => (e.key === 'Enter' ? addDataField(e) : e)}
                    onBlur={(e) => addDataField(e)}
                  />
                </div>

                <span className="icon" onClick={(e) => addDataField(e)}>
                  <i className="fa fa-plus"></i>
                </span>
              </div>

              {Object.keys(datafields)
                .sort()
                .map((key, i) => {
                  const item = datafields[key];
                  return (
                    <div key={item.id} className="double-input mb-3">
                      <div className='inputs'>
                        <input
                          name={`decisions.${item.id}.text`}
                          className="form-control"
                          placeholder="variable name"
                          defaultValue={item.text}
                          onChange={onEdited}
                          onBlur={(e) => {
                            Chatbot.setBlockData(block.id, {data: {[item.id]: {id: item.id, text: e.target.value}}});
                          }}
                        />
                        <input
                          id={`${item.id}.value`}
                          name={`decisions.${item.id}.value`}
                          className="form-control"
                          placeholder="value"
                          defaultValue={item.value}
                          onChange={onEdited}
                          onBlur={(e) =>
                            Chatbot.setBlockData(block.id, {data: {[item.id]: {id: item.id, value: e.target.value}}})
                          }
                        />
                      </div>
                      <span className="icon red" onClick={(e) => removeDataField(e, item.id)}>
                        <i className="fa fa-trash-alt"></i>
                      </span>
                    </div>
                  );
              })}
            </>
          )}

         
  </>
  

)
};
